// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECTS_ID}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTS_ID,
  storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECTS_ID}.appspot.com`,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(app);
let firebaseAnalytics = null;

// Initialize Analytics when supported; otherwise fall back to mock logging.
isSupported()
  .then((supported) => {
    if (!supported) {
      console.warn("Firebase Analytics is not supported in this environment");
      return;
    }
    firebaseAnalytics = getAnalytics(app);
  })
  .catch((err) => {
    console.warn("Firebase Analytics init failed:", err?.message || err);
  });

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
  minimumFetchIntervalMillis: 3600000,
};
remoteConfig.defaultConfig = {
  nexus_token_enable: false,
};

fetchAndActivate(remoteConfig).catch((err) => {
  console.error("Remote Config fetch failed:", err);
});

const logFirebaseEvent = (eventName, params = {}) => {
  if (!firebaseAnalytics) {
    console.log("[Mock] Event:", eventName, params);
    return;
  }
  try {
    console.log(eventName, params);
    logEvent(firebaseAnalytics, eventName, params);
  } catch (error) {
    console.error("Analytics error:", error);
  }
};

export {
  firebaseAuth,
  remoteConfig,
  getValue,
  app as firebaseApp,
  firebaseAnalytics,
  logFirebaseEvent,
};
